export default __webpack_public_path__ + "static/media/img2.b636f5ab.jpg";